import React from 'react';
import glamorous from 'glamorous';

import Subtitle from '../typography/Subtitle';

import { media, palette } from '../../styles';

const Div = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
  padding: 16,
  marginBottom: 8,

  [media('sm')]: {
    padding: 32,
    marginBottom: 16,
  },

  backgroundColor: '#fff',
  border: `4px solid ${palette.default.lightest}`,
});

const Title = glamorous.div({
  marginBottom: 16,
  paddingBottom: 16,
  borderBottom: '4px solid #e8e9e8',
});

export default (props) => (
  <Div>
    <Title>
      <Subtitle style={{ margin: 0 }}>
        {props.title}
      </Subtitle>
    </Title>
    {props.children}
  </Div>
);



// WEBPACK FOOTER //
// ./src/components/demo/StickersheetRow.js